<template>
  <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
    <navegar-atras ruta="/liquidaciones"></navegar-atras>
    <div class="row w-100">
      <div class="col-6">
        <datos-factura-form :es-autofactura="esAutofactura" :liquidaciones-seleccionadas="liquidacionesSeleccionados" :rappels-seleccionados="rappelsSeleccionados" @factura-creada="onFacturaCreated"/>
      </div>
      <div class="col-6 d-flex flex-column justify-content-start gap-3 mb-3">
        <div class="mb-3">
          <h1>{{$t("datos_factura.liquidaciones.titulo")}}</h1>
          <liquidaciones-grid ref="liquidacionesGrid" :filtro-pendientes="true" :reduced="true" :filas-seleccionables="true" @actualizar-liquidaciones="actualizarLiquidaciones" :seleccionar-todas="esAutofactura"/>
        </div>
        <div class="mb-3">
          <h1>{{$t("datos_factura.rappels.titulo")}}</h1>
          <rappels-mensuales-grid ref="rappelsGrid" :filtro-pendientes="true" :reduced="true" :filas-seleccionables="true" @actualizar-rappels="actualizarRappels" :seleccionar-todas="esAutofactura"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavegarAtras from "@/components/NavegarAtras.vue";
import LiquidacionesGrid from "@/components/liquidaciones/LiquidacionesGrid.vue";
import RappelsMensualesGrid from "@/components/liquidaciones/RappelsMensualesGrid.vue";
import DatosFacturaForm from "@/components/liquidaciones/DatosFacturaForm.vue";
import { ref } from "vue";

const props = defineProps({
  esAutofactura: Boolean
})

const liquidacionesSeleccionados = ref([]);
const rappelsSeleccionados = ref([]);
const liquidacionesGrid = ref();
const rappelsGrid = ref();

const actualizarLiquidaciones = (nuevoValor: any) => {
  liquidacionesSeleccionados.value = nuevoValor;
};

const actualizarRappels = (nuevoValor: any) => {
  rappelsSeleccionados.value = nuevoValor;
};

const onFacturaCreated = () => {
  liquidacionesSeleccionados.value = [];
  rappelsSeleccionados.value = [];
  liquidacionesGrid.value.refreshGrid();
  rappelsGrid.value.refreshGrid();
}
</script>

<style scoped>

</style>